/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

export const notNullOrUndefined = <T extends {}>(
  value: T | null | undefined,
): value is T => {
  return value !== null && value !== undefined
}

export const dedupById = <T extends { id: string }>(items: T[]): T[] => {
  return items.reduce<T[]>((uniqueItems, item) => {
    const match = uniqueItems.find(i => i.id === item.id)
    if (match) {
      return uniqueItems
    } else {
      return [...uniqueItems, item]
    }
  }, [])
}

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

/**
 * Adds 's' to a word for counts greater than 1
 * @param word
 * @param count
 * @param ignore
 * @returns formatted string
 */
export const plurality = (
  word: string,
  count: number,
  ignore?: string[],
): string => {
  if (ignore && ignore.includes(word.toLowerCase())) return word
  const plural = count === 1 || word.endsWith('s') ? '' : 's'
  return `${word}${plural}`
}
